"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HistoryTable = void 0;
var _core = require("@material-ui/core");
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _styles = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _pittaModules = require("@thingsw/pitta-modules");
var _Fonts = require("../constants/Fonts");
var _Link = require("./Link");
var _Typography = require("./Typography");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TableHeaderCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      padding: theme.spacing(1)
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    //@ts-ignore
    head: _objectSpread(_objectSpread({}, _Fonts.Fonts.Default.Small), {}, {
      color: _pittaModules.LightColors.primary["2"]
    })
  });
})(_TableCell.default);
var TableCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      padding: theme.spacing(1.5, 1),
      width: "25%"
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    //@ts-ignore
    body: _objectSpread(_objectSpread({}, _Fonts.Fonts.Default.Body), {}, {
      color: _pittaModules.LightColors.primary["1"],
      verticalAlign: "top"
    })
  });
})(_TableCell.default);
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    rowHover: {
      "&:hover": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["10"], "!important")
      }
    },
    overF: {
      width: "100%",
      overflow: "auto"
    },
    width: {
      minWidth: 672
    },
    nowrap: {
      whiteSpace: "nowrap"
    }
  };
});
var HistoryTable = function HistoryTable(_ref) {
  var history = _ref.history,
    onClick = _ref.onClick,
    black = _ref.black,
    t = _ref.t;
  var classes = useStyles();
  var renderTable = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
      className: classes.overF
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      className: classes.width,
      "aria-label": "simple table"
    }, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(TableHeaderCell, null, t("Date")), /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
      align: "right",
      style: {
        textAlign: "right"
      }
    }, t("Amount, USD")), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null, t("Method")), /*#__PURE__*/_react.default.createElement(TableHeaderCell, null, t("Details")))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, _lodash.default.map(history, function (history) {
      return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        classes: {
          hover: classes.rowHover
        }
      }, /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.nowrap
      }, history.date), /*#__PURE__*/_react.default.createElement(TableCell, {
        align: "right",
        style: {
          textAlign: "right"
        }
      }, (history.amount / 100).toFixed(2)), /*#__PURE__*/_react.default.createElement(TableCell, null, history.method), /*#__PURE__*/_react.default.createElement(TableCell, null, black ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Body",
        htmlColor: _pittaModules.LightColors.primary["1"]
      }, t("Subscription")) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
        category: "Default",
        variant: "Body",
        mode: "anchor",
        target: "_blank",
        to: history.details
      }, t("Subscription"))));
    }))));
  }, [classes.overF, classes.width, classes.rowHover, classes.nowrap, t, history, black]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderTable());
};
exports.HistoryTable = HistoryTable;